import { defineComponent as _defineComponent } from 'vue'
import { Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { MAX_ASPECTS_COLLAPSED } from '../config';
  import { PRAISED_TITLE, CAVEATS_TITLE } from '../lib/reviewSummaryLabels';
  import { useReviewSummary } from '../lib/useReviewSummary';

  interface ReviewSummaryTeaserEmits {
    (e: 'scroll-to-overview'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewSummaryTeaser',
  emits: ["scroll-to-overview"],
  setup(__props, { emit }: { emit: ({
    (e: 'scroll-to-overview'): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const { hasSummary, praised, caveats } = useReviewSummary();

  const teaserPraised = computed(() => praised.value.slice(0, MAX_ASPECTS_COLLAPSED));
  const teaserCaveats = computed(() => caveats.value.slice(0, MAX_ASPECTS_COLLAPSED));

return { __sfc: true,emit, hasSummary, praised, caveats, teaserPraised, teaserCaveats, Typo, TypoVariant, PRAISED_TITLE, CAVEATS_TITLE }
}

})